import React from "react";
import WeekTimesheetView from "./WeekTimesheetView";

const MyTimesheets: React.FC = () => {
  return <WeekTimesheetView />;
};

export default MyTimesheets;
